import { cloneDeep } from 'lodash-es';
import { ServiceErrorDescriptor } from '../error/index.js';
import { removeUndefined } from '../utils/objects.js';
import BaseService from './BaseService.js';
import { DefaultBadRequestError, DefaultMethodNotAllowedError, DefaultNotAcceptableError, DefaultNotFoundError, DefaultServiceUnavailableError, DefaultTooManyRequestsError, DefaultUnauthorizedError, InternalServiceError, ValidationError, } from './defaultErrors.js';
import { serviceStore } from './stores.js';
const SERVICE_METADATA_SYMBOL = Symbol('service:metadata');
class ServiceDescriptor {
    OwnerClass;
    serviceMetadata;
    coreMethodsMetadata;
    restMethodsMetadata;
    grpcMethodsMetadata;
    constructor(target, stored) {
        this.OwnerClass = target;
        serviceStore[this.OwnerClass.name] = this.OwnerClass;
        if (stored) {
            this.serviceMetadata = cloneDeep(stored.serviceMetadata);
            this.coreMethodsMetadata = cloneDeep(stored.coreMethodsMetadata);
            this.restMethodsMetadata = cloneDeep(stored.restMethodsMetadata);
            this.grpcMethodsMetadata = cloneDeep(stored.grpcMethodsMetadata);
        }
        this.serviceMetadata = {
            ...this.serviceMetadata,
            core: {
                serviceName: this.OwnerClass.name,
            },
        };
    }
    addServiceMetadata(channel, meta) {
        this.serviceMetadata[channel] = {
            ...this.serviceMetadata[channel],
            ...removeUndefined(meta),
        };
        this.save();
    }
    addCoreMethodMetadata(methodName, meta) {
        if (meta.request && !meta.throws.includes(ValidationError)) {
            meta.throws.push(ValidationError);
        }
        if (!meta.throws.includes(InternalServiceError)) {
            meta.throws.push(InternalServiceError);
        }
        const defaultErrors = [
            DefaultBadRequestError,
            DefaultUnauthorizedError,
            DefaultNotFoundError,
            DefaultMethodNotAllowedError,
            DefaultNotAcceptableError,
            DefaultTooManyRequestsError,
            DefaultServiceUnavailableError,
        ];
        defaultErrors.forEach((defaultError) => {
            const requiredStatus = ServiceErrorDescriptor.load(defaultError).status;
            if (!meta.throws.some((ServiceError) => ServiceErrorDescriptor.load(ServiceError).status === requiredStatus)) {
                meta.throws.push(defaultError);
            }
        });
        this.coreMethodsMetadata = {
            ...this.coreMethodsMetadata,
            [methodName]: removeUndefined(meta),
        };
        this.save();
    }
    addRestMethodMetadata(methodName, meta) {
        this.restMethodsMetadata = {
            ...this.restMethodsMetadata,
            [methodName]: {
                ...this.restMethodsMetadata?.[methodName],
                ...removeUndefined(meta),
            },
        };
        this.save();
    }
    addGrpcMethodMetadata(methodName, meta) {
        this.grpcMethodsMetadata = {
            ...this.grpcMethodsMetadata,
            [methodName]: {
                ...this.grpcMethodsMetadata?.[methodName],
                ...removeUndefined(meta),
            },
        };
        this.save();
    }
    save() {
        if (!this.serviceMetadata.core.package) {
            this.serviceMetadata.core.package = `lbg.cbbt.${this.serviceMetadata.core.serviceName}`;
        }
        Reflect.defineMetadata(SERVICE_METADATA_SYMBOL, this, this.OwnerClass.prototype);
    }
    static load(target) {
        const targetProto = target instanceof BaseService ? target : target.prototype;
        const targetCtor = target instanceof BaseService ? target.constructor : target;
        const stored = Reflect.getMetadata(SERVICE_METADATA_SYMBOL, targetProto);
        if (!stored || stored.OwnerClass !== target) {
            return new ServiceDescriptor(targetCtor, stored);
        }
        else {
            return stored;
        }
    }
}
export default ServiceDescriptor;
//# sourceMappingURL=ServiceDescriptor.js.map